import styled from 'styled-components'

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${props => (props.theme === true ? '#231f20' : '#ffffff')};
`

export const LoginCard = styled.div`
  height: 358px;
  width: 420px;
  max-width: 90%;
  border-radius: 15px;
  border: none;
  box-shadow: 2px 2px 6px 6px
    ${props => (props.theme === true ? '#f9f9f9' : ' #1e293b')};
`

export const LogoImg = styled.img`
  height: 42px;
  width: 150px;
  align-self: center;
  margin-bottom: 22px;
`

export const FormContainer = styled.form`
  height: 100%;
  padding: 22px;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 15px;
  border: none;
  background-color: ${props => (props.theme === true ? '#000000' : '#ffffff')};
`
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const InputLabel = styled.label`
  margin-bottom: 4px;
  font-family: 'Roboto';
  font-size: 12px;
  font-weight: 600;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#606060')};
`

export const InputEl = styled.input`
  width: 100%;
  height: 36px;
  padding: 6px;
  border: 1px solid ${props => (props.theme === true ? '#475569' : '#ebebeb')};
  border-radius: 4px;
  outline: none;
  font-family: 'Roboto';
  font-size: 15px;
  font-weight: 400;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#616e7c')};
  background-color: transparent;
  margin-bottom: 10px;
`

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 12px;
  height: 19px;
`

export const CheckboxInput = styled.input`
  height: 17px;
  width: 17px; /* Corrected typo */
  margin-right: 7px;
  cursor: pointer;
  align-self: center;
`

export const CheckboxLabel = styled(InputLabel)`
  cursor: pointer;
  font-weight: 600;
  align-self: center;
  font-size: 13px;
  color: ${props => (props.theme === true ? '#ffffff' : '#212121')};
`
export const LoginBtn = styled.button`
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  outline: none;
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background-color: #3b82f6;
`
export const ErrMsgPara = styled.p`
  font-family: 'Roboto';
  font-size: 13px;
  font-weight: 400;

  color: #ff0000;
`
